export const submitFieldCSS = {
  top: 0,
  right: 0,
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  padding: 0,
  background: 'transparent',
  color: 'var(--app-color)',
  cursor: 'pointer',
  borderRadius: '10px',
  ':hover': {
    backgroundColor: '#F0F4F4',
    color: '#2b4252',
  },
  height: '58px'
};

export const removeFieldCSS = {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  padding: 0,
  background: 'transparent',
  color: 'var(--app-color)',
  cursor: 'pointer',
  borderRadius: '10px',
  ':hover': {
    backgroundColor: '#F0F4F4',
    color: '#2b4252',
  },
  height: '58px'
};


export const toggleEditArrowCSS = {

  padding: 0,
  margin: 0,
  position: 'absolute',
  top: 0,
  right: 0, // Move the button to the right-most side
  '&:hover': {
    backgroundColor: 'rgba(255, 255, 255, 0.1)',
  },
};


export const fieldInputCSS = (fieldKeysWithError = [], key = '') => ({
  width: '100%',
  '& .MuiInputBase-root': {
    height: 40,
    backgroundColor: 'white',
    border: fieldKeysWithError.includes(key) ? '1px solid red' : 'inherit',
  },
  '& .MuiOutlinedInput-input': {
    height: 40,
    width: '100%',
    border: fieldKeysWithError.includes(key) ? '1px solid red' : 'inherit',
  }
});


export const barcodeCheckboxCSS = (fieldKeysWithError = [], key = '') => ({
  p: 0,
  m: 0,
  ml: '2px',
  height: '10px',
  width: '10px',
  '& .MuiSvgIcon-root': { fontSize: '30px' },
  borderColor: fieldKeysWithError.includes(key) ? 'red' : 'inherit',
}
);
